import React from "react";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  container: {
    // backgroundColor: "#ffffff",
    textAlign: "center",
    marginTop: theme.spacing.unit * 3,
    paddingTop: theme.spacing.unit * 5,
    paddingBottom: theme.spacing.unit * 5
  }
});

function Footer(props) {
  const { classes } = props;
  return (
    <footer className={classes.container}>
      <Typography variant="caption">
        Bug report: <a href="mailto:minhtcx@gmail.com">minhtcx@gmail.com</a>
        <br />
        Build with{" "}
        <span role="img" aria-label="heart">
          ❤️
        </span>{" "}
        by the JUNCTIONxHanoi Team. <br />
      </Typography>
    </footer>
  );
}

export default withStyles(styles)(Footer);
